module.exports = __webpack_public_path__ + "img/lens-167-minus-11.c8fad8fd.png";